export default "__VITE_ASSET__e23c4cc7__"